var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-text',[_c('JuegoSet')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }